import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp, NativeStackScreenProps } from '@react-navigation/native-stack';

import { LoadingSpinner } from '@/components/LoadingSpinner';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { useDeposit } from '@/feature/deposit/hooks/use-deposit';
import { useActiveProductName } from '@/hooks/use-active-product-name';
import { usePreventAndroidBackNavigation } from '@/hooks/use-prevent-android-back-navigation';
import { DepositStackParamList } from '@/navigation/types';
import { getWalletErrorCode } from '@/utils/get-wallet-error-code';

import { PaymentMethodTypes } from '../const';

type ScreenProps = NativeStackScreenProps<DepositStackParamList, 'FantasyMoneyDepositScreen'>;

export const FantasyMoneyDepositScreen = ({ route }: ScreenProps) => {
    const { currency = 'USD' } = route.params || {};
    const navigation = useNavigation<NativeStackNavigationProp<DepositStackParamList>>();
    const { t } = useTranslation(['kyc', 'wallet']);
    const productName = useActiveProductName();
    const { mutate: deposit } = useDeposit();

    usePreventAndroidBackNavigation();

    useEffect(() => {
        deposit(
            {
                type: PaymentMethodTypes.FantasyMoney,
                currency,
            },
            {
                onSuccess: () => {
                    navigation.navigate('SuccessfulDepositModal', {
                        paymentProvider: PaymentMethodTypes.FantasyMoney,
                    });
                },
                onError: error => {
                    navigation.navigate('FailedDepositModal', {
                        paymentProvider: PaymentMethodTypes.FantasyMoney,
                        errorCode: getWalletErrorCode(error),
                    });
                },
            }
        );
    }, [navigation, deposit, currency, productName, t]);

    return (
        <Box
            flex={1}
            justifyContent="center"
            alignItems="center"
            backgroundColor={ds.colorToken.background.neutral.base}
        >
            <LoadingSpinner />
        </Box>
    );
};
